// Leichte Format-Helfer ohne Decoder-Abhaengigkeiten. Liegen bewusst nicht in imageOps.ts:
// das zieht heic2any (~1,3 MB) mit, und uploadService -> Warenkorb-Widget (auf jeder
// Shopseite geladen) braucht nur diese beiden Funktionen.

export function isHeicBlob(blob: Blob): boolean {
    const type = String(blob?.type || '').toLowerCase()
    return type.includes('heic') || type.includes('heif')
}

export function isTiffBlob(blob: Blob): boolean {
    const type = String(blob?.type || '').toLowerCase()
    return type.includes('tif') || type.includes('tiff')
}

export function toJpegFileName(name: string): string {
    const base = String(name || 'bild').replace(/\.[^.]+$/, '')
    return `${base || 'bild'}.jpg`
}
